import React, { Component } from "react";
import { message, Alert, Typography, Checkbox, Select } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  InputNumberItem,
  SelectItem,
  NotificacionPolizas,
} from "../../../../../Components/Items";

const { Text } = Typography;
const { Option } = Select;

class ModalDividirVenta extends Component {
  state = {
    guardando: false,
    selecciones: {}, // insumoLineaId -> { incluir, bucket, cantidad }
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ selecciones: {}, guardando: false });
    }
  }

  resolverInsumo(insumoId) {
    return (this.props.todasInsumos || []).find(
      (valueInsumo) => valueInsumo._id.toString() === insumoId.toString()
    );
  }

  actualizarSeleccion(insumoLineaId, cambios) {
    this.setState({
      selecciones: {
        ...this.state.selecciones,
        [insumoLineaId]: {
          ...this.state.selecciones[insumoLineaId],
          ...cambios,
        },
      },
    });
  }

  dividir() {
    const selecciones = Object.entries(this.state.selecciones)
      .filter(([, valueSeleccion]) => valueSeleccion.incluir && Number(valueSeleccion.cantidad) > 0)
      .map(([insumoLineaId, valueSeleccion]) => ({
        insumoLineaId,
        cantidad: Number(valueSeleccion.cantidad),
        bucket: valueSeleccion.bucket,
      }));

    if (selecciones.length === 0) {
      message.warning("Selecciona al menos un insumo y una cantidad para dividir.");
      return;
    }

    this.setState({ guardando: true });
    axios
      .post(
        "ventas/dividirVentaPorPartidas",
        { empresaId: this.props.empresaId, ventaId: this.props.ventaId, selecciones },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          NotificacionPolizas(res.data.polizasId);
          this.props.cerrarDividirVenta({ folio: res.data.folio, ventaId: res.data.ventaId });
        } else {
          message.error(res.data.message || "Sucedió un error y no se dividió la remisión.");
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        message.error("Sucedió un error y no se dividió la remisión.");
      });
  }

  render() {
    const insumos = (this.props.insumos || []).filter((valueInsumo) => Number(valueInsumo.cantidad || 0) > 0);

    return (
      <ModalItem
        title="Dividir Remisión para Facturar"
        visible={this.props.visible}
        spinning={this.state.guardando}
        onCancel={() => this.props.cerrarDividirVenta(null)}
        paddingTop
        destroyOnClose
        width="70%"
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 15 }}
          message="Elige qué insumos (y qué cantidad) se van a mover a una venta copia nueva. La original se queda con el resto. Un insumo con entregas parciales no puede mezclar, en la misma partida, cantidad entregada y no entregada."
        />

        <table className="table" style={{ width: "100%", marginBottom: 10 }}>
          <thead>
            <tr>
              <th className="th-border" style={{ width: "5%", padding: 6 }}></th>
              <th className="th-border" style={{ width: "34%", padding: 6 }}>Insumo</th>
              <th className="th-border" style={{ width: "12%", padding: 6 }}>Cantidad</th>
              <th className="th-border" style={{ width: "12%", padding: 6 }}>Entregado</th>
              <th className="th-border" style={{ width: "12%", padding: 6 }}>No Entregado</th>
              <th className="th-border" style={{ width: "12%", padding: 6 }}>Mover De</th>
              <th className="th-border" style={{ width: "13%", padding: 6 }}>Cantidad a Mover</th>
            </tr>
          </thead>
          <tbody>
            {insumos.map((valueInsumo) => {
              const insumoCatalogo = this.resolverInsumo(valueInsumo.insumoId);
              const cantidad = Number(valueInsumo.cantidad || 0);
              const entregado = Number(valueInsumo.entregado || 0);
              const noEntregado = Math.max(cantidad - entregado, 0);
              const soloUnBucket = entregado <= 0 ? "noEntregado" : noEntregado <= 0 ? "entregado" : null;

              const seleccion = this.state.selecciones[valueInsumo._id] || {
                incluir: false,
                bucket: soloUnBucket || "entregado",
                cantidad: 0,
              };
              const disponible = seleccion.bucket === "entregado" ? entregado : noEntregado;

              return (
                <tr key={valueInsumo._id}>
                  <td className="td-border" style={{ textAlign: "center" }}>
                    <Checkbox
                      checked={!!seleccion.incluir}
                      onChange={(e) => this.actualizarSeleccion(valueInsumo._id, { incluir: e.target.checked, bucket: seleccion.bucket })}
                    />
                  </td>
                  <td className="td-border">
                    <Text strong>
                      {insumoCatalogo?.clave ? insumoCatalogo.clave + " - " : ""}
                      {insumoCatalogo?.descripcion || insumoCatalogo?.nombre || "Insumo"}
                    </Text>
                  </td>
                  <td className="td-border" style={{ textAlign: "center" }}>{cantidad}</td>
                  <td className="td-border" style={{ textAlign: "center" }}>{entregado}</td>
                  <td className="td-border" style={{ textAlign: "center" }}>{noEntregado}</td>
                  <td className="td-border">
                    {soloUnBucket ? (
                      <Text type="secondary">
                        {soloUnBucket === "entregado" ? "Entregado" : "No entregado"}
                      </Text>
                    ) : (
                      <SelectItem
                        value={seleccion.bucket}
                        style={{ width: "100%" }}
                        onChange={(value) => this.actualizarSeleccion(valueInsumo._id, { bucket: value, cantidad: 0 })}
                      >
                        <Option value="entregado">Entregado</Option>
                        <Option value="noEntregado">No entregado</Option>
                      </SelectItem>
                    )}
                  </td>
                  <td className="td-border">
                    <InputNumberItem
                      min={0}
                      max={disponible}
                      disabled={!seleccion.incluir}
                      value={seleccion.cantidad}
                      placeholder={"Max: " + disponible}
                      style={{ width: "100%" }}
                      onChange={(v) => this.actualizarSeleccion(valueInsumo._id, { cantidad: v })}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <ButtonItem
          type="primary"
          moradoB
          style={{ display: "block", margin: "10px 0 0 auto" }}
          onClick={this.dividir.bind(this)}
        >
          Dividir Remisión
        </ButtonItem>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalDividirVenta);
